export class Email {

  address: string;

  constructor(address: string) {
    this.address = address;
  }

}
